var borderActions;
(function (borderActions) {
    borderActions["GET"] = "GET";
    borderActions["GET_BORDERS"] = "GET_BORDERS";
})(borderActions || (borderActions = {}));
export default borderActions;
